import getHtmlParam from '../../utilities/htmlParam';

export async function getPrice(articleId: string, quantity: number, type?: string, design?: string, bestprice?: boolean, productId?: string) {
    const params = getHtmlParam('.js-param .param');
    let parameters = '';
    parameters += 'quantity=' + quantity;
    parameters += '&';
    parameters += 'campaignCode=' + params.get('campaignCodes');
    parameters += '&';
    parameters += 'promoCode=' + params.get('promoCodes');
    parameters += '&';
    parameters += 'profile=' + params.get('profile');
    parameters += '&';
    parameters += 'language=' + params.get('clientLocale');
    parameters += '&';
    parameters += 'legalCountry=' + params.get('legalCountry');
    parameters += '&';
    parameters += 'deliveryCountry=' + params.get('deliveryCountry');
    parameters += '&';
    parameters += 'identitySub=' + params.get('identitySub');
    parameters += '&';
    parameters += 'tenant=' + params.get('tenant');
    parameters += '&';
    parameters += 'username=' + params.get('identUsername');
    parameters += '&';
    parameters += 'isGuest=' + params.get('getIdentIsGuest');
    parameters += '&';
    if(design == 'v3') {
        parameters += 'design=v3';
    } else {
        parameters += 'design=v2';
    }
    parameters += '&';
    parameters += 'type=' + type || '';

    let url = params.get('urlPrefix') + '/pricing/article/' + articleId + '?' + parameters;

    if (bestprice) {
        url = params.get('urlPrefix') + '/pricing/bestprice/' + productId + '?articleId=' + articleId + '&' + parameters;
    }

    return await window.fetch(url)
        .then(res => res.text())
        .then((html) => {
            return html;
        }).catch(err => {
          console.log(err);
        });
}

export function updateScaledPrice(quantity: string) {
    if (quantity === 'NaN' || quantity === '' || typeof quantity === 'undefined') {
        return;
    }
    let resultsScaledPrice = document.querySelector('.results-scaledprice');
    if (resultsScaledPrice) {
        const articleId = document.querySelector('.pda').getAttribute('data-article-id');
        let design: string = '';
        if(document.querySelector('.pda.pda-v3')) {
            design = 'v3';
        }
        getPrice(articleId, parseInt(quantity), '', design).then((articlePriceSnippet: any) => {
            resultsScaledPrice.parentNode.removeChild(resultsScaledPrice);
            document.getElementById('article-price').innerHTML = articlePriceSnippet;
            resultsScaledPrice = document.querySelector('.results-scaledprice');
            const pdaCtaBox = document.querySelector('.pda-cta-box');
            if (resultsScaledPrice) {
                if(document.querySelector('.pda.pda-v3') && document.querySelector('.best-prc-wrapper') ) {
                    document.querySelector('.best-prc-wrapper').appendChild(resultsScaledPrice);
                } else {
                    pdaCtaBox.appendChild(resultsScaledPrice);
                }
            }
            const stickyPriceDetailOffer = document.querySelector('.pda-sticky-cta .price-detail-offer');
            const stickyPriceBasePrice = document.querySelector('.pda-sticky-cta .prc-baseprice');
            const PriceDetailOffer = document.querySelector('.pda-cta-price .price-detail-offer');
            const PriceBasePrice = document.querySelector('.pda-cta-price .prc-baseprice');
            stickyPriceDetailOffer && (stickyPriceDetailOffer.innerHTML = PriceDetailOffer.textContent);
            PriceBasePrice && stickyPriceBasePrice && (stickyPriceBasePrice.innerHTML = PriceBasePrice.textContent);
        });
    }
}
